import { render, staticRenderFns } from "./MyProgress.vue?vue&type=template&id=48fd24b8&"
import script from "./MyProgress.vue?vue&type=script&lang=js&"
export * from "./MyProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports